// extracted by mini-css-extract-plugin
export var csatScore = "_n7-5";
export var header = "_n7-1";
export var panelWrapper = "_n7-2";
export var postPreview = "_n7-3";
export var rightContent = "_n7-0";
export var wrappingText = "_n7-4";